import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import './presentacion.css';

const Presentacion = () => {
    const navigate = useNavigate();
    const [currentSlide, setCurrentSlide] = useState(0);
    const audioRef = useRef(null);
    const [audioStarted, setAudioStarted] = useState(false);

    const isFileProtocol = window.location.protocol === 'file:';
    const audioSrc = isFileProtocol ? "presentacion.mp3" : "/presentacion.mp3";
    const heroBg = isFileProtocol ? "presentacion_hero.png" : "/presentacion_hero.png";

    const slides = [
        {
            title: "ARCHIPEG PRO",
            text: "Donde la tecnología se encuentra con tus fotos y vídeos más valiosos. Redescubre tu historia personal con inteligencia y elegancia.",
            bg: heroBg,
            type: "hero"
        },
        {
            title: "EL MAPA DE TU VIDA",
            text: "Cada recuerdo tiene un lugar. Visualiza tus viajes y momentos especiales geolocalizados en un mapa interactivo de alta resolución.",
            bg: "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?auto=format&fit=crop&q=80&w=2000",
            type: "content"
        },
        {
            title: "MAGIC SCAN",
            text: "La herramienta definitiva. Conecta un USB con tus fotos y vídeos y Archipeg hará todo el trabajo sucio por ti: importar, organizar y fechar.",
            bg: "https://images.unsplash.com/photo-1563986768609-322da13575f3?auto=format&fit=crop&q=80&w=2000",
            type: "magic"
        },
        {
            title: "CERO DUPLICADOS",
            text: "Archipeg analiza tu colección y detecta archivos repetidos automáticamente. Mantén tu archivo limpio, ligero y sin desorden.",
            bg: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?auto=format&fit=crop&q=80&w=2000",
            type: "content"
        },
        {
            title: "IDENTIFICA A TU FAMILIA",
            text: "Crea perfiles para tus seres queridos. Etiqueta a las personas en tus recuerdos y encuentra todos sus momentos con un solo click.",
            bg: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&q=80&w=2000",
            type: "content"
        },
        {
            title: "SELECCIÓN FAVORITOS",
            text: "Tus joyas de la corona. Marca tus recuerdos preferidos con la estrella (⭐) y crea tu propia galería VIP instantáneamente.",
            bg: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&q=80&w=2000",
            type: "content"
        },
        {
            title: "GUÍA RÁPIDA DE USO",
            text: "Domina Archipeg en cuatro pasos sencillos y pon orden a tu historia.",
            bg: heroBg,
            type: "summary"
        },
        {
            title: "¿LISTO PARA EMPEZAR?",
            text: "Tu archivo digital está esperando. Toma el control total de tu legado visual hoy mismo.",
            bg: heroBg,
            type: "final"
        }
    ];

    // Temporizador de Diapositivas
    useEffect(() => {
        const timer = setInterval(() => {
            if (currentSlide < slides.length - 1) {
                setCurrentSlide(prev => prev + 1);
            }
        }, 8000);
        return () => clearInterval(timer);
    }, [currentSlide, slides.length]);

    // Limpiador de Audio al Salir
    useEffect(() => {
        return () => {
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0;
            }
        };
    }, []);

    const startExperience = () => {
        if (audioRef.current) {
            audioRef.current.play().catch(e => console.log("Auto-play blocked, waiting for interaction"));
            setAudioStarted(true);
        }
        if (currentSlide === slides.length - 1) {
            navigate('/galeria');
        } else {
            setCurrentSlide(prev => prev + 1);
        }
    };

    return (
        <div className="presentacion-container" onClick={() => {
            if (!audioStarted) {
                startExperience();
            } else {
                if (currentSlide < slides.length - 1) {
                    setCurrentSlide(prev => prev + 1);
                } else {
                    navigate('/galeria');
                }
            }
        }}>
            <audio ref={audioRef} src={audioSrc} loop preload="auto" crossOrigin="anonymous" />
            
            {audioStarted && (
                <>
                    {currentSlide > 0 && (
                        <div style={{ position: 'absolute', left: '20px', top: '50%', transform: 'translateY(-50%)', fontSize: '4rem', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', zIndex: 1000, userSelect: 'none' }} onClick={(e) => { e.stopPropagation(); setCurrentSlide(prev => prev - 1); }}>
                            ❮
                        </div>
                    )}
                    {currentSlide < slides.length - 1 && (
                        <div style={{ position: 'absolute', right: '20px', top: '50%', transform: 'translateY(-50%)', fontSize: '4rem', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', zIndex: 1000, userSelect: 'none' }} onClick={(e) => { e.stopPropagation(); setCurrentSlide(prev => prev + 1); }}>
                            ❯
                        </div>
                    )}
                </>
            )}
            
            {!audioStarted && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 10000,
                    background: 'var(--acento-turquesa)',
                    color: '#000',
                    padding: '10px 20px',
                    borderRadius: '50px',
                    fontWeight: 'bold',
                    boxShadow: '0 0 20px var(--acento-turquesa)',
                    animation: 'pulse 2s infinite',
                    cursor: 'pointer'
                }}>
                    🎵 HAZ CLIC PARA ACTIVAR EL SONIDO
                </div>
            )}

            {slides.map((slide, index) => (
                <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                    <img src={slide.bg} alt="bg" className="slide-bg" />

                    <div className="slide-content glass-panel">
                        <h1 className="slide-title">{slide.title}</h1>
                        <div className="neon-line"></div>
                        <p className="slide-text" style={{ opacity: 1 }}>{slide.text}</p>

                        {slide.type === 'magic' && (
                            <div className="instruction-grid">
                                <div className="instruction-item">
                                    <span className="step-number">01</span>
                                    <p>Conecta tu USB o Disco Externo al PC.</p>
                                </div>
                                <div className="instruction-item">
                                    <span className="step-number">02</span>
                                    <p>Crea la carpeta <strong>FOTOS PARA SUBIR</strong>.</p>
                                </div>
                                <div className="instruction-item">
                                    <span className="step-number">03</span>
                                    <p>Pulsa <strong>MAGIC SCAN</strong> en el panel Admin.</p>
                                </div>
                            </div>
                        )}

                        {slide.type === 'summary' && (
                            <div className="instruction-grid summary-grid">
                                <div className="instruction-item">
                                    <span className="step-number">01</span>
                                    <h3>CONECTAR</h3>
                                    <p>Usa Magic Scan para importar desde USB.</p>
                                </div>
                                <div className="instruction-item">
                                    <span className="step-number">02</span>
                                    <h3>MAPEAR</h3>
                                    <p>Visualiza tus rutas en el Mapa Satelital.</p>
                                </div>
                                <div className="instruction-item">
                                    <span className="step-number">03</span>
                                    <h3>PERSONAS</h3>
                                    <p>Identifica y agrupa a tus seres queridos.</p>
                                </div>
                                <div className="instruction-item">
                                    <span className="step-number">04</span>
                                    <h3>LIMPIAR</h3>
                                    <p>Elimina duplicados y organiza por eventos.</p>
                                </div>
                            </div>
                        )}

                        {index === slides.length - 1 && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center', marginTop: '25px' }}>
                                <button className="btn-primary-neon" style={{ opacity: 1, padding: '15px 30px', fontSize: '1.2rem', cursor: 'pointer', width: '100%', maxWidth: '300px' }} onClick={(e) => {
                                    e.stopPropagation();
                                    navigate('/galeria');
                                }}>
                                    ENTRAR A LA GALERÍA
                                </button>
                                <a 
                                    href={`${API_BASE_URL}/downloads/Archipeg Pro Setup 2.3.4.exe`}
                                    className="btn-secondary-neon"
                                    style={{
                                        opacity: 1,
                                        padding: '12px 24px',
                                        fontSize: '1rem',
                                        cursor: 'pointer',
                                        textDecoration: 'none',
                                        textAlign: 'center',
                                        border: '1px solid var(--acento-turquesa)',
                                        color: 'var(--acento-turquesa)',
                                        width: '100%',
                                        maxWidth: '300px',
                                        borderRadius: '8px',
                                        fontWeight: '700'
                                    }}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    📥 DESCARGAR DEMO PC
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            ))}

            <div className="controls">
                {slides.map((_, index) => (
                    <div
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            setCurrentSlide(index);
                        }}
                    />
                ))}
            </div>

            {!audioStarted && (
                <div className="click-overlay" style={{
                    position: 'absolute',
                    top: 0, left: 0, width: '100%', height: '100%',
                    background: 'rgba(0,0,0,0.5)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    zIndex: 10000, pointerEvents: 'none'
                }}>
                    <p style={{ fontSize: '1.2rem', color: '#00ffff', animation: 'fadeIn 1s infinite alternate' }}>
                        HAGA CLICK PARA INICIAR LA EXPERIENCIA
                    </p>
                </div>
            )}
        </div>
    );
};

export default Presentacion;
